export { default } from './DenFraudesGolpe';
